(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfValidateModel', [
    '$timeout', function($timeout) {
      return {
        restrict: 'A',
        link: function($scope, element, attrs, mfValidate) {
          return $timeout(function() {
            var mfValidateElement;
            mfValidateElement = element.closest('[mf-validate]');
            return mfValidateElement.scope().$validationController.registerInput(element);
          });
        }
      };
    }
  ]);

}).call(this);
